export default __webpack_public_path__ + "static/media/640_store05-it-mobile.fddd9ace.png";